module.exports = __webpack_public_path__ + "static/img/nav.7bd13704.png";